import { Routes, BrowserRouter, Route } from "react-router-dom";
import Home from "./Home";
import About from "./About";
import Agriculture from "./Agriculture";
import Products from "./Products";
import WasteRecycle from "./WasteRecycle";
import DiscoverMore from "./DiscoverMore";
import Story from "./Story";
import "./i18n";
import "./index.less";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/story" element={<Story />} />
        <Route path="/agriculture" element={<Agriculture />} />
        <Route path="/wasteRecycle" element={<WasteRecycle />} />
        <Route path="/discoverMore" element={<DiscoverMore />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;